function filterParams(options) {
  const params = []
  for (const key in options) {
    const value = options[key]
    if (value) {
      params.push(value)
    }
  }
  return params
}

export default axios => ({
  async register(reqBody) {
    const url = '/user/create/'
    const body = {
      login: reqBody.login,
      email: reqBody.email,
      password: reqBody.password,
      birthday: reqBody.birthDay
    }
    if (reqBody.referral) {
      body.ref = reqBody.referral
    }
    return (await axios.post(url, body)).data.data
  },

  async logIn(reqBody) {
    const url = '/token/'
    const body = {
      login: reqBody.login,
      password: reqBody.password
    }
    return (await axios.post(url, body)).data.data
  },

  async logOut() {
    const url = '/user/logout/'
    return (await axios.post(url)).data.data
  },

  async getUserInfo() {
    const url = '/user/profile/'
    return (await axios.get(url)).data.data
  },

  async getUserBalance() {
    const url = '/user/balance/'
    return (await axios.get(url)).data.data
  },

  async updateUserProfile(reqBody) {
    const reqData = new FormData()
    if (reqBody) {
      reqData.append('login', reqBody.login)
      reqData.append('email', reqBody.email)
      if (reqBody.avatar) {
        reqData.append('avatar', reqBody.avatar)
      }
      if (
        reqBody.old_password ||
        reqBody.new_password ||
        reqBody.confirm_new_password
      ) {
        reqData.append('old_password', reqBody.old_password)
        reqData.append('new_password', reqBody.new_password)
        reqData.append('confirm_new_password', reqBody.confirm_new_password)
      }
    }

    const url = 'user/profile/'
    return (await axios.put(url, reqData)).data.data
  },

  async getTournamentsHistory({page, size, id}) {
    const url = 'user/tournaments-history/'
    let pageSize = size === 'all' ? '' : size
    const body = {
      page,
      size: pageSize,
      stage__tournament__id: id
    }
    return (await axios.get(url, {params: body})).data.data
  },

  async getMemberships() {
    const url = '/memberships/'
    return (await axios.get(url)).data.data
  },

  async getPayin(reqOptions) {
    // console.log(reqOptions)
    const url = `/payin/data/${reqOptions.currency}`
    const params = reqOptions.currency
    return (await axios.get(url, {params})).data.data
  },

  async setPayin({amount}) {
    const url = '/payin/invoice'
    const data = {
      amount,
      currency: 'RUB'
    }
    return (await axios.post(url, data)).data.data
  },

  async getTransactionsHistory({page, size}) {
    const url = '/user/balance-transactions/'
    let pageSize = size === 'all' ? '' : size
    const body = {
      page,
      size: pageSize
    }
    return (await axios.get(url, {params: body})).data.data
  },

  async getUserSettings() {
    const url = '/user/game-settings/'
    return (await axios.get(url)).data.data
  },

  async updateNicknames(arr) {
    const url = '/user/game-settings/bulk-update-or-create/'

    const filteredArr = filterParams(arr)

    const data = {
      user_game_settings: filteredArr
    }
    return (await axios.post(url, data)).data.data
  },

  async getPayout({amount, account}) {
    const url = '/payout/try/'
    const data = {
      amount,
      account
    }
    return (await axios.post(url, data)).data.data
  },

  async resetPassword(email) {
    const url = '/user/password_reset/'
    const data = {
      email
    }
    return (await axios.post(url, data)).data.data
  },

  async getSocialLinks() {
    const url = '/user/social-links/'
    return (await axios.get(url)).data.data
  },

  async setSocialLinks(reqData) {
    const url = '/user/social-links/'

    const data = {
      whatsapp_phone: reqData.whatsapp,
      vk_link: reqData.vk,
      telegram_username: reqData.telegram,
      facebook_link: reqData.facebook,
      viber_phone: reqData.viber,
      twitter_link: reqData.twitter,
      instagram_link: reqData.instagram
    }

    return (await axios.put(url, data)).data.data
  },

  async getUserStatistic() {
    const url = '/user/statistics/'
    return (await axios.get(url)).data
  },

  async validateToken(token) {
    const url = '/user/password_reset/validate_token/'
    return (await axios.post(url, {token})).data.data
  },

  async setNewPassword(reqData) {
    const url = '/user/password_reset_confirm/'
    const data = {
      uid: reqData.uid,
      token: reqData.token,
      password: reqData.new_password
    }
    return (await axios.post(url, data)).data.data
  },

  async activateAccount(reqData) {
    const url = '/user/activate/'
    const data = {
      uid: reqData.uid,
      token: reqData.token
    }
    return (await axios.post(url, data)).data.data
  },

  async checkPasswordToken(reqData) {
    const url = '/user/check_password_token/'
    const data = {
      uid: reqData.uid,
      token: reqData.token
    }
    return (await axios.post(url, data)).data.data
  },

  async connectGame(reqData) {
    const url = '/user/game-settings/'
    const data = {
      game: reqData.game,
      nickname: reqData.nickname,
      settings: {}
    }
    return (await axios.post(url, data)).data.data
  }
})



// WEBPACK FOOTER //
// ./src/pkg/api/user.js